module.exports = __webpack_public_path__ + "static/img/one.f8b5908.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/wardrobeImg/one.png
// module id = Kp22
// module chunks = 1